import { render, staticRenderFns } from "./service-container.vue?vue&type=template&id=337bdf42&scoped=true&"
import script from "./service-container.vue?vue&type=script&lang=ts&"
export * from "./service-container.vue?vue&type=script&lang=ts&"
import style0 from "./service-container.vue?vue&type=style&index=0&id=337bdf42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bdf42",
  null
  
)

export default component.exports